export namespace FontSizes {
  export const mini: string = '10px';
  export const xSmall: string = '11px';
  export const small: string = '12px';
  export const smallPlus: string = '13px';
  export const medium: string = '14px';
  export const mediumPlus: string = '15px';
  export const icon: string = '16px';
  export const large: string = '17px';
  export const xLarge: string = '21px';
  export const xLargePlus: string = '21px';
  export const xxLarge: string = '28px';
  export const xxLargePlus: string = '28px';
  export const superLarge: string = '42px';
  export const mega: string = '72px';
}
